module.exports = __webpack_public_path__ + "static/media/direct-download (1).831c3a43.png";